<script lang="ts" setup>
import ProductsSearchResultTable from "~/widgets/search/products/ProductsSearchResultTable.vue";
import Spinner from '~/components/ui/preloader/Spinner.vue';
import useSearchStore from "~/shared/store/modules/search";
import useMainStore from '~~/shared/store';
import config from "~/shared/config";
// import sortingProductsByCoords from "~/composables/sort-by-coords";
import getProductTable from '~/composables/get-product-table'

const { article, brand } = defineProps<{
  article: string
  brand: string
}>()

const isLoading = ref(false)
const searchStore = useSearchStore()
const mainStore = useMainStore();

const { defaultCitySlug } = config();
const hasWarehouses = ref(false);

const showWarehousesCount = 3;

watch(() => mainStore.sotransCitySelected, async () => {
  await getProductsList();
});

onMounted(async () => {
  await getProductsList();
})

onBeforeUnmount(() => {
  searchStore.$reset;
})

async function getProductsList() {
  isLoading.value = true

  const citySlug = mainStore.sotransCitySelected?.slug ?? defaultCitySlug;

  const products = await getProductTable({
    article,
    brand,
    citySlug
  });

  if (products?.data) {
    const {originalProduct, productAnalogsList} = products.data;
    hasWarehouses.value = Boolean(originalProduct || productAnalogsList.length)
    // sortingProductsByCoords(originalProduct);
    // productAnalogsList.forEach(el => {
    //   sortingProductsByCoords(el);
    // })
    searchStore.initSearchProductsList(products.data);
  }

  isLoading.value = false
}

</script>

<template>
  <section class="product-table" id="productTable">
    <div class="container">
      <h2 class="product-table__title" v-if="searchStore.getSearchProductData.original">Цены и наличие</h2>
      <div class="search__table search__table_products">
        <Spinner
          v-if="isLoading"
        />
        <ProductsSearchResultTable
          v-if="!isLoading && searchStore.getSearchProductData.original"
          :has-table-header="true"
          :products="searchStore.getSearchProductData.original ? [searchStore.getSearchProductData.original] : []"
          :show-warehouses-count="showWarehousesCount"
          :is-original-product="true"
        />
        <ProductsSearchResultTable
          v-if="!isLoading && searchStore.getSearchProductData.analogs"
          table-title="Возможные аналоги"
          :has-table-header="!Boolean(searchStore.getSearchProductData.original)"
          :products="searchStore.getSearchProductData.analogs"
          :show-warehouses-count="showWarehousesCount"
          :is-original-product="false"
        />
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.product-table {
  padding-top: 60px;
  @include md-breakpoint {
    background-color: $bg_page;
    margin-top: 16px;
    padding: 20px 0;
    border-radius: 12px 12px 0 0;
  }

  .container {
    @include md-breakpoint {
      padding: 0;
    }
  }

  &__title {
    @include font(20px, 24px, 600);
    @include md-breakpoint {
      padding: 0 20px;
    }
  }

  .search__table {
    //min-height: 145px;
    display: flex;
    flex-direction: column;

    &_products {
      margin-top: 16px;
      @include md-breakpoint {
        margin-top: 24px;
      }
    }
  }
}
</style>
